
export interface TourStep {
    target: string; // CSS selector for the element to highlight
    title: string;
    description: string;
    position?: 'top' | 'bottom' | 'left' | 'right' | 'auto';
}

// Default tour steps for LUCA - mobile-friendly order
export const defaultTourSteps: TourStep[] = [
    {
        target: '[data-tour="simple-mode-toggle"]',
        title: "Your Focus Zone 🌟",
        description: "Toggle this to switch between 'Simple Mode' (for focused study) and 'Advanced Mode' (for power tools).",
        position: 'bottom'
    },
    {
        target: '[data-tour="chat-input"]',
        title: "Your Personal Tutor ✨",
        description: "Ask me anything here! I can explain tricky concepts, solve problems, or just chat about your review.",
        position: 'top'
    },
    {
        target: '[data-tour="quick-actions"]',
        title: "Study Tools 🛠️",
        description: "Need a quiz? Want to check flashcards? All your essential tools are just a click away.",
        position: 'top'
    },
    {
        target: '[data-tour="attach-file"]',
        title: "Analyze Your Notes 📄",
        description: "Upload a photo of a problem or a PDF of your notes. I'll read it and help you understand it.",
        position: 'top'
    },
    {
        target: '[data-tour="new-chat"]',
        title: "Fresh Start 💬",
        description: "Click here to start a new conversation topic. I'll remember our past chats in the sidebar.",
        position: 'right'
    },
];
